import React, { useState } from 'react';
import { ChevronDown, CheckCircle2, Circle, Clock, Info } from 'lucide-react';

const CollapsibleTaskRow = ({ row, rowIndex, onStatusChange }) => {
    const [expanded, setExpanded] = useState(false);

    const isChecked = row.Status === 'Completed' || row.Status === true || row.Status === 'TRUE';
    const hasNotes = row.Notes && row.Notes.trim() !== '';

    return (
        <tr key={rowIndex} className="border-b-[16px] border-slate-100/30 last:border-0">
            <td colSpan="100%" className="p-0">
                <div className={`bg-white group/row transition-all hover:bg-slate-50/10 shadow-sm hover:shadow-md ${isChecked ? 'opacity-75' : ''}`}>
                    <div className="px-8 py-7 flex items-start gap-6">
                        {/* Task Checkbox / Number */}
                        <div className="flex-shrink-0 relative">
                            <button
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onStatusChange(!isChecked);
                                }}
                                className={`w-12 h-12 rounded-2xl flex items-center justify-center transition-all duration-500 shadow-lg ${isChecked ? 'bg-emerald-500 shadow-emerald-500/20' : 'bg-slate-100 group-hover/row:bg-blue-50'}`}
                            >
                                {isChecked ? (
                                    <CheckCircle2 size={24} className="text-white" />
                                ) : (
                                    <span className="text-slate-400 font-black text-lg group-hover/row:text-blue-600">{rowIndex + 1}</span>
                                )}
                            </button>
                        </div>

                        <div className="flex-1">
                            <div className="flex items-center gap-3 mb-1">
                                <span className={`text-[10px] font-black uppercase tracking-[0.2em] px-2 py-0.5 rounded-md ${isChecked ? 'bg-emerald-50 text-emerald-600' : 'bg-blue-50 text-blue-600'}`}>
                                    {row.Task_ID || 'Task'}
                                </span>
                                <span className="text-[10px] font-black text-slate-400 uppercase tracking-[0.2em] bg-slate-50 px-2 py-0.5 rounded-md flex items-center gap-1">
                                    <Clock size={10} /> {row.Status || 'Pending'}
                                </span>
                            </div>
                            <h3 className={`text-xl font-extrabold tracking-tight leading-tight transition-all duration-500 ${isChecked ? 'text-slate-400 line-through' : 'text-slate-800'}`}>
                                {row.Task_Description || 'New Action Task'}
                            </h3>
                            {row.Area && (
                                <p className="text-[11px] text-slate-400 font-bold uppercase tracking-widest mt-2 flex items-center gap-2">
                                    <span className={`w-1.5 h-1.5 rounded-full ${isChecked ? 'bg-emerald-300' : 'bg-blue-400'}`}></span>
                                    {row.Area}
                                </p>
                            )}
                        </div>

                        {/* Expand Button for Notes */}
                        {hasNotes && (
                            <button
                                onClick={() => setExpanded(!expanded)}
                                className={`p-3 rounded-xl transition-all ${expanded ? 'bg-blue-600 text-white rotate-180' : 'bg-slate-50 text-slate-400 hover:bg-blue-50 hover:text-blue-600'}`}
                            >
                                <ChevronDown size={20} />
                            </button>
                        )}
                    </div>

                    {/* Collapsible Notes */}
                    {expanded && hasNotes && (
                        <div className="px-8 pb-8 animate-in slide-in-from-top-4 duration-500">
                            <div className="bg-slate-50/50 rounded-[2rem] border border-slate-100 p-8">
                                <div className="flex items-center gap-2 mb-4">
                                    <Info size={16} className="text-blue-600" />
                                    <span className="text-[11px] font-black text-slate-400 uppercase tracking-widest">Guidance & Notes</span>
                                </div>
                                <p className="text-slate-600 text-sm leading-relaxed font-medium whitespace-pre-wrap">
                                    {row.Notes}
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </td>
        </tr>
    );
};

export default CollapsibleTaskRow;
